export const TRX_CODE_OPTIONS = [
  { value: "01", label: "invoices.trxCodes.01" },
  { value: "02", label: "invoices.trxCodes.02" },
  { value: "03", label: "invoices.trxCodes.03" },
  { value: "04", label: "invoices.trxCodes.04" },
  { value: "06", label: "invoices.trxCodes.06" },
  { value: "07", label: "invoices.trxCodes.07" },
  { value: "08", label: "invoices.trxCodes.08" },
  { value: "09", label: "invoices.trxCodes.09" },
  { value: "10", label: "invoices.trxCodes.10" },
];

export const BUYER_DOCUMENT_OPTIONS = [
  { value: "TIN", label: "invoices.buyerDocs.taxID" },
  { value: "NIK", label: "invoices.buyerDocs.nationalID" },
  { value: "Passport", label: "invoices.buyerDocs.passport" },
  { value: "Other", label: "invoices.buyerDocs.other" },
];

export const DEFAULT_TRX_CODE = "04";
export const DEFAULT_BUYER_COUNTRY = "IDN";
export const DEFAULT_BUYER_DOCUMENT = "TIN";
export const DEFAULT_UNIT = "UM.0001";
export const DEFAULT_NON_NPWP_TIN = "0000000000000000";

export const BUYER_TIN_PATTERN = /^\d{16}$/;

export const UNIT_CODE_PATTERN = /^UM\.\d{4}$/;

export const TAX_INVOICE_OPT_OPTIONS = [
  { value: "Normal", label: "invoices.taxInvoiceOpts.normal" },
  { value: "Pengganti", label: "invoices.taxInvoiceOpts.replacement" },
];

export const DEFAULT_TAX_INVOICE_OPT = "Normal";
export const DEFAULT_IDTKU_BRANCH = "000000";
export const DEFAULT_GS_CODE = "000000";

export const BRANCH_CODE_PATTERN = /^\d{6}$/;

export const NITKU_PATTERN = /^\d{22}$/;

export { UNIT_CODE_OPTIONS } from "./coretaxData/unitCodes";
export { COUNTRY_CODE_OPTIONS } from "./coretaxData/countryCodes";
export { GOOD_SERVICE_CODE_OPTIONS } from "./coretaxData/goodServiceCodes";

export const BUYER_DOC_NUMBER_RULES = {
  TIN: {
    pattern: /^\d{16}$/,
    maxLength: 16,
    numeric: true,
    errorKey: "invoices.errors.buyerDocNumberTin",
  },
  NIK: {
    pattern: /^\d{16}$/,
    maxLength: 16,
    numeric: true,
    errorKey: "invoices.errors.buyerDocNumberNik",
  },
  Passport: {
    pattern: /^[A-Za-z0-9]{6,8}$/,
    maxLength: 8,
    numeric: false,
    errorKey: "invoices.errors.buyerDocNumberPassport",
  },
  Other: { pattern: null, maxLength: 50, numeric: false, errorKey: "" },
};
